import { currencyFormat } from 'common/helpers/numberHelper';

const CartSummary = (props) => {
  const { cart, settings } = props;
  if (!cart.items) {
    return (
      <div className="c7-product-quickshop__summary">
        <span className="c7-cart__count">0</span>{' '}
        <span className="c7-cart__total">{currencyFormat(0, settings)}</span>
      </div>
    );
  }
  const itemCount = cart.items.reduce(
    (total, item) => total + item.quantity,
    0
  );
  return (
    <div className="c7-product-quickshop__summary">
      <span className="c7-cart__count">{itemCount}</span>{' '}
      <span className="c7-cart__total">
        {currencyFormat(cart.total, settings)}
      </span>
      <a href="/checkout" className="c7-button">
        Proceed to Checkout
      </a>
    </div>
  );
};

export default CartSummary;
